import React, { useEffect, useState } from "react";
import BASEURL from "../../Utils/Baseurl";
import {
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormHelperText,
  Icon,
  Stack,
  ButtonGroup,
  IconButton,
} from "@mui/material";
import ConfirmationDialog from "../../../components/Dialog/ConfirmationDialog";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import MaterialButton from "../../../components/MaterialButton";
import Grid from "@mui/material/Grid2";
import DashboardLayout from "../../../layoutcontainers/DashboardLayout";
import MaterialBox from "../../../components/MaterialBox";
import MaterialTypography from "../../../components/MaterialTypography";
import MaterialSelect from "../../../components/MasterSelect";
import MaterialInput from "../../../components/MaterialInput";
import { BsFillPersonVcardFill } from "react-icons/bs";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useLocation, useNavigate } from "react-router-dom";
import { gql } from "graphql-request";
import { request } from "graphql-request";
import { useLoading } from "../../../context/loading";
import Swal from "sweetalert2";

const SalaryAdvance = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setCirleLoading } = useLoading();
  const id = location?.state?.id || null;
  const [employeeOptions, setEmployeeOptions] = useState([]);
  const [togglePage, setTogglePage] = useState({
    view: id ? true : false,
    edit: false,
  });
  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
  };
  const paymentOptions = [
    { value: "Cash", label: "Cash" },
    { value: "Account Transfer", label: "Account Transfer" },
  ];
  const rePaymentOptions = [
    { value: "Full Payment", label: "Full Payment" },
    { value: "Installment", label: "Installment" },
  ];

  const employeeTypeOptions = [
    { value: "Staff", label: "Staff" },
    { value: "Operators", label: "Operators" },
  ];

  const categoryOptions = [
    { value: "Category 1", label: "Category 1" },
    { value: "Category 2", label: "Category 2" },
    { value: "Category 3", label: "Category 3" },
    { value: "Category 4", label: "Category 4" },
  ];

  const [advanceData, setAdvanceData] = useState({
    employeeType: "",
    category: "",
    employee: "",
    employeeId: "",
    amount: "",
    requestedOn: "",
    paymentMode: "",
    repaymentMode: "",
    installMonth: "",
    installAmount: "",

    employeeTypeStatus: "unchecked",
    categoryStatus: "unchecked",
    employeeStatus: "unchecked",
    employeeIdStatus: "unchecked",
    amountStatus: "unchecked",
    requestedOnStatus: "unchecked",
    paymentModeStatus: "unchecked",
    repaymentModeStatus: "unchecked",
    installMonthStatus: "unchecked",
    installAmountStatus: "unchecked",
  });

  const [originalData, setOriginalData] = useState({
    employeeType: "",
    category: "",
    employee: "",
    employeeId: "",
    amount: "",
    requestedOn: "",
    paymentMode: "",
    repaymentMode: "",
    installMonth: "",
    installAmount: "",
  });

  useEffect(() => {
    const today = new Date().toLocaleDateString("en-CA", {
      timeZone: "Asia/Kolkata", // IST time zone
    });

    setAdvanceData((prev) => ({
      ...prev,
      requestedOn: today,
      requestedOnStatus: "success",
    }));
  }, []);

  const fetchSalaryAdvanceById = gql`
    query SalaryAdvanceById($id: ID!) {
      salaryAdvanceById(id: $id) {
        id
        user {
          id
          firstName
          lastName
        }
        employeeId
        category
        employeeType
        amount
        requestedOn
        paymentMode
        repaymentType

        installment
      }
    }
  `;

  const employeeAndId = gql`
    query {
      allUsersDetail {
        id
        firstName
        empid
        email
        category
      }
    }
  `;

  useEffect(() => {
    const fetchEmployeeDetails = async () => {
      try {
        const resp = await request(BASEURL, employeeAndId);

        if (resp?.allUsersDetail) {
          const formattedEmployees = resp.allUsersDetail.map((user) => ({
            value: user.id,
            label: user.firstName,
            empid: user.empid,
            category: user.category,
          }));
          let temp = [];
          if (advanceData.category) {
            temp = formattedEmployees.filter(
              (item) => item?.category == advanceData.category
            );
          } else {
            temp = formattedEmployees;
          }
          setEmployeeOptions(temp);
        }
      } catch (error) {
        console.error("Error fetching Employee Details", error);
      }
    };

    fetchEmployeeDetails();
  }, [advanceData.category]);

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    onConfirm: () => {},
    onCancel: () => {},
  });
  const handleDropdownChange = (name, selectedValue) => {
    setAdvanceData((prev) => ({
      ...prev,
      [name]: selectedValue,
      [`${name}Status`]: "success",
    }));
  };

  const createSalaryAdvance = `
    mutation CreateSalaryAdvance($input: SalaryAdvanceInput!) {
      createSalaryAdvance(input: $input) {
        salaryAdvance {
          id
          employeeType
          category
          employee
          employeeId
          amount
          requestedOn
          paymentMode
          repaymentType 
          installment 
        }
      }
    }
  `;
  const updateSalaryAdvance = `
  mutation UpdateSalaryAdvance($id: ID!, $input: SalaryAdvanceInput!) {
    updateSalaryAdvance(id: $id, input: $input) {
      salaryAdvance {
        id
        employeeType
        category
        employee
        employeeId
        amount
        requestedOn
        paymentMode
      }
    }
  }
`;

  const handleSubmitSalaryAdvance = async () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to submit your salary advance details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: async () => {
        setCirleLoading(true);
        const input = {
          employeeType: advanceData.employeeType,
          category: advanceData.category,
          employee: advanceData.employee,
          employeeId: advanceData.employeeId,
          amount: parseFloat(advanceData.amount),
          requestedOn: advanceData.requestedOn,
          paymentMode: advanceData.paymentMode,
          repaymentType: advanceData?.repaymentMode,
          installment: advanceData?.installMonth,
        };

        try {
          if (togglePage.edit) {
            await request(BASEURL, updateSalaryAdvance, { id, input });
            Swal.fire({
              position: "center",
              icon: "success",
              title: "Updated Successfully!",
              showConfirmButton: false,
              timer: 2500,
            });
          } else {
            await request(BASEURL, createSalaryAdvance, { input });
            Swal.fire({
              position: "center",
              icon: "success",
              title: "Created Successfully!",
              showConfirmButton: false,
              timer: 2500,
            });
          }

          navigate("/salary-advance");
        } catch (error) {
          console.error("Error submitting salary advance:", error);

          const errorMessage =
            error?.response?.errors?.[0]?.message ||
            "An unexpected error occurred.";
          if (errorMessage) {
            Swal.fire({
              position: "center",
              icon: "error",
              title: errorMessage,
              showConfirmButton: false,
              timer: 2500,
            });
          }
        } finally {
          setCirleLoading(false);
          setConfirmationDialog({ ...confirmationDialog, open: false });
        }
      },
      onCancel: () => {
        setConfirmationDialog({ ...confirmationDialog, open: false });
      },
    });
  };

  useEffect(() => {
    if (id) {
      const fetchSalaryAdvance = async () => {
        setCirleLoading(true);
        try {
          const response = await request(BASEURL, fetchSalaryAdvanceById, {
            id,
          });

          if (response?.salaryAdvanceById) {
            const salaryAdvance = response.salaryAdvanceById;

            setAdvanceData((prev) => ({
              ...prev,
              category: salaryAdvance.category || "",
              employeeType: salaryAdvance.employeeType || "",
              employee: salaryAdvance.user
                ? `${salaryAdvance.user.firstName} ${salaryAdvance.user.lastName}`
                : "",
              employeeId: salaryAdvance.employeeId || "",
              amount:
                salaryAdvance.amount !== undefined
                  ? String(salaryAdvance.amount)
                  : "",
              requestedOn: salaryAdvance.requestedOn || "",
              paymentMode: salaryAdvance.paymentMode || "",
              repaymentMode: salaryAdvance?.repaymentType || "",
              repaymentModeStatus: salaryAdvance?.repaymentType
                ? "success"
                : "unchecked",
              installMonth: salaryAdvance?.installment || "",
              installMonthStatus: salaryAdvance?.installment
                ? "success"
                : "unchecked",
              installAmount: parseFloat(
                (salaryAdvance.amount / salaryAdvance?.installment).toFixed(2)
              ),
              categoryStatus: salaryAdvance.category ? "success" : "unchecked",
              employeeTypeStatus: salaryAdvance.employeeType
                ? "success"
                : "unchecked",
              employeeStatus: salaryAdvance.user ? "success" : "unchecked",
              employeeIdStatus: salaryAdvance.employeeId
                ? "success"
                : "unchecked",
              amountStatus: salaryAdvance.amount ? "success" : "unchecked",
              requestedOnStatus: salaryAdvance.requestedOn
                ? "success"
                : "unchecked",
              paymentModeStatus: salaryAdvance.paymentMode
                ? "success"
                : "unchecked",
            }));

            setOriginalData(salaryAdvance);
          }
        } catch (error) {
          console.error("Error fetching salary advance:", error);
        } finally {
          setCirleLoading(false);
        }
      };

      fetchSalaryAdvance();
    }
  }, [id]);

  const deleteSalaryAdvanceMutation = `
    mutation DeleteSalaryAdvance($id: ID!) {
      deleteSalaryAdvance(id: $id) {
        success
      }
    }
  `;
  const handleDeleteSalaryAdvance = async () => {
    if (!id) return;

    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to delete this salary advance record?",
      showCancel: true,
      showConfirm: true,
      onConfirm: async () => {
        setCirleLoading(true);
        try {
          await request(BASEURL, deleteSalaryAdvanceMutation, { id });
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Deleted Successfully!",
            showConfirmButton: false,
            timer: 2500,
          });
          navigate("/salary-advance");
        } catch (error) {
          console.error("Error deleting salary advance:", error);
          setConfirmationDialog({
            open: true,
            title: "Error",
            message: error.message,
            onConfirm: () => setConfirmationDialog({ open: false }),
          });
        } finally {
          setCirleLoading(false);
          setConfirmationDialog({ ...confirmationDialog, open: false });
        }
      },
      onCancel: () => {
        setConfirmationDialog({ ...confirmationDialog, open: false });
      },
    });
  };

  const handleAmountError = (event) => {
    const { name, value } = event.target;
    const updatedState = { ...advanceData };

    if (name === "amount") {
      const amountRegex = /^[0-9]*\.?[0-9]*$/;

      if (value.trim() === "") {
        updatedState.amountStatus = "unchecked";
        updatedState.amount = "";
        updatedState.installMonth = "";
        updatedState.installAmount = "";
        updatedState.installMonthStatus = "unchecked";
      } else if (amountRegex.test(value)) {
        updatedState.amountStatus = "success";
        updatedState.amount = value;

        const month = parseInt(updatedState.installMonth);
        if (month >= 1 && month <= 12) {
          updatedState.installAmount = (value / month).toFixed(2);
        } else {
          updatedState.installAmount = "";
        }
      } else {
        updatedState.amountStatus = "error";
      }
    }

    if (name === "installMonth") {
      const month = parseInt(value);

      if (value.trim() === "") {
        updatedState.installMonthStatus = "unchecked";
        updatedState.installMonth = "";
        updatedState.installAmount = "";
      } else if (!isNaN(month) && month >= 1 && month <= 12) {
        updatedState.installMonthStatus = "success";

        if (updatedState.amount && !isNaN(updatedState.amount)) {
          updatedState.installAmount = (updatedState.amount / month).toFixed(2);
        } else {
          updatedState.installAmount = "";
        }
      } else {
        updatedState.installMonthStatus = "error";
      }
      updatedState.installMonth = value;
    }

    setAdvanceData(updatedState);
  };

  const handleDiscard = () => {
    setAdvanceData({
      ...originalData,
      employeeTypeStatus: originalData.employeeType ? "success" : "unchecked",
      categoryStatus: originalData.category ? "success" : "unchecked",
      employeeStatus: originalData.user?.firstName ? "success" : "unchecked",
      employeeIdStatus: originalData.employeeId ? "success" : "unchecked",
      amountStatus: originalData.amount ? "success" : "unchecked",
      requestedOnStatus: originalData.requestedOn ? "success" : "unchecked",
      paymentModeStatus: originalData.paymentMode ? "success" : "unchecked",
    });

    setTogglePage({ view: true, edit: false });
  };

  const checkAllFields = () => {
    return (
      (advanceData.repaymentMode !== "Installment" ||
        advanceData.installMonthStatus === "success") &&
      advanceData.employeeTypeStatus === "success" &&
      advanceData.categoryStatus === "success" &&
      advanceData.employeeStatus === "success" &&
      advanceData.employeeIdStatus === "success" &&
      advanceData.amountStatus === "success" &&
      advanceData.requestedOnStatus === "success" &&
      advanceData.paymentModeStatus === "success" &&
      advanceData.repaymentModeStatus === "success"
    );
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}

      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="row" spacing={0}>
                <IconButton
                  onClick={() => {
                    navigate("/salary-advance");
                  }}
                  sx={{ mr: 1, mt: -0.7 }}
                >
                  <ArrowBackIcon />
                </IconButton>{" "}
                <MaterialTypography variant="h5" fontWeight="medium">
                  {togglePage.edit
                    ? "Update Salary Advance details"
                    : togglePage.view
                    ? "View Salary Advance details"
                    : "Add Salary Advance Details"}
                </MaterialTypography>
              </Stack>
              {togglePage.view && (
                <ButtonGroup
                  variant="outlined"
                  aria-label="Loading button group"
                >
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    onClick={toggleEdit}
                    startIcon={<EditIcon />}
                  >
                    Edit
                  </MaterialButton>
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    onClick={handleDeleteSalaryAdvance}
                    startIcon={<DeleteIcon />}
                  >
                    Delete
                  </MaterialButton>
                </ButtonGroup>
              )}
            </Stack>
          }
        />

        <CardContent sx={{ minHeight: "60vh" }}>
          <Stack direction="row" spacing={1}>
            <BsFillPersonVcardFill style={{ fontSize: 20 }} />
            <MaterialTypography
              component="label"
              variant="body2"
              fontWeight="bold"
            >
              Salary Advance information
            </MaterialTypography>
          </Stack>

          <Grid direction="row" container spacing={1}>
            <Grid size={{ xs: 12, sm: 4, lg: 6 }}>
              <MaterialBox lineHeight={0} display="inline-block">
                <MaterialTypography
                  component="label"
                  variant="caption"
                  fontWeight="bold"
                >
                  Type<span style={{ color: "red" }}>*</span>
                </MaterialTypography>
              </MaterialBox>
              <MaterialSelect
                name="employeeType"
                value={
                  employeeTypeOptions.find(
                    (type) => type.value === advanceData.employeeType
                  ) || ""
                }
                options={employeeTypeOptions}
                onChange={(selectedOption) =>
                  handleDropdownChange("employeeType", selectedOption.value)
                }
                success={
                  advanceData.employeeTypeStatus === "success" ? true : false
                }
                isDisabled={togglePage.view}
              ></MaterialSelect>
            </Grid>

            <Grid size={{ xs: 12, sm: 4, lg: 6 }}>
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Category<span style={{ color: "red" }}>*</span>
              </MaterialTypography>
              <MaterialSelect
                name="category"
                value={
                  categoryOptions.find(
                    (cat) => cat.value === advanceData.category
                  ) || ""
                }
                onChange={(selectedOption) =>
                  handleDropdownChange("category", selectedOption.value)
                }
                options={categoryOptions}
                success={
                  advanceData.categoryStatus === "success" ? true : false
                }
                isDisabled={togglePage.view}
              ></MaterialSelect>
            </Grid>

            <Grid size={{ xs: 12, sm: 4, lg: 6 }}>
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Employee<span style={{ color: "red" }}>*</span>
              </MaterialTypography>
              <MaterialSelect
                name="employee"
                value={
                  employeeOptions.find(
                    (emp) => emp.empid === advanceData.employeeId
                  ) || ""
                }
                options={employeeOptions}
                onChange={(selectedOption) => {
                  setAdvanceData((prev) => ({
                    ...prev,
                    employee: selectedOption.label,
                    employeeId: selectedOption.empid,
                    employeeStatus: "success",
                    employeeIdStatus: "success",
                  }));
                }}
                success={
                  advanceData.employeeStatus === "success" ? true : false
                }
                isDisabled={togglePage.view}
              ></MaterialSelect>
            </Grid>

            <Grid size={{ xs: 12, sm: 4, lg: 6 }}>
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Employee ID<span style={{ color: "red" }}>*</span>
              </MaterialTypography>
              <MaterialInput
                name="employeeId"
                value={advanceData.employeeId}
                success={
                  advanceData.employeeIdStatus === "success" ? true : false
                }
                disabled
              ></MaterialInput>
            </Grid>

            <Grid size={{ xs: 12, sm: 4, lg: 6 }}>
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Requested On<span style={{ color: "red" }}>*</span>
              </MaterialTypography>
              <MaterialInput
                type="date"
                name="requestedOn"
                value={advanceData.requestedOn || ""}
                onChange={(event) => {
                  const value = event.target.value;

                  setAdvanceData((prev) => ({
                    ...prev,
                    requestedOn: value,
                    requestedOnStatus: value ? "success" : "unchecked",
                  }));
                }}
                success={advanceData.requestedOnStatus === "success"}
                disabled
              />
            </Grid>

            <Grid size={{ xs: 12, sm: 4, lg: 6 }}>
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Payment Mode<span style={{ color: "red" }}>*</span>
              </MaterialTypography>
              <MaterialSelect
                name="paymentMode"
                value={
                  paymentOptions.find(
                    (mode) => mode.value === advanceData.paymentMode
                  ) || ""
                }
                customStyles={{ optionPadding: 20 }}
                onChange={(selectedOption) =>
                  handleDropdownChange("paymentMode", selectedOption.value)
                }
                options={paymentOptions}
                success={
                  advanceData.paymentModeStatus === "success" ? true : false
                }
                isDisabled={togglePage.view}
              ></MaterialSelect>
            </Grid>

            <Grid size={{ xs: 12, sm: 4, lg: 6 }}>
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Amount<span style={{ color: "red" }}>*</span>
              </MaterialTypography>
              <MaterialInput
                name="amount"
                type="number"
                value={advanceData.amount || ""}
                placeholder="eg. 10000"
                error={advanceData.amountStatus === "error" ? true : false}
                inputProps={{
                  maxLength: 50,
                }}
                onKeyDown={(e) => {
                  if (["e", "E", "+", "-"].includes(e.key)) {
                    e.preventDefault();
                  }
                }}
                sx={{
                  "& input::-webkit-inner-spin-button, & input::-webkit-outer-spin-button":
                    {
                      WebkitAppearance: "none",
                      margin: 0,
                    },
                  "& input": {
                    MozAppearance: "textfield",
                  },
                }}
                onChange={handleAmountError}
                success={advanceData.amountStatus === "success"}
                disabled={togglePage.view}
                icon={{
                  direction: "right",
                  component: (
                    <Icon color="action" fontSize="small">
                      <CurrencyRupeeIcon />
                    </Icon>
                  ),
                }}
              />
              {advanceData.amountStatus === "error" && (
                <FormControl error>
                  <FormHelperText>
                    Amount should contain only numbers
                  </FormHelperText>
                </FormControl>
              )}
            </Grid>

            <Grid size={{ xs: 12, sm: 4, lg: 6 }}>
              <MaterialTypography
                component="label"
                variant="caption"
                fontWeight="bold"
              >
                Repayment Mode<span style={{ color: "red" }}>*</span>
              </MaterialTypography>
              <MaterialSelect
                name="repaymentMode"
                value={
                  rePaymentOptions.find(
                    (mode) => mode.value === advanceData.repaymentMode
                  ) || ""
                }
                customStyles={{ optionPadding: 20 }}
                onChange={(selectedOption) =>
                  handleDropdownChange("repaymentMode", selectedOption.value)
                }
                options={rePaymentOptions}
                success={
                  advanceData.repaymentModeStatus === "success" ? true : false
                }
                isDisabled={togglePage.view}
              ></MaterialSelect>
            </Grid>
            {advanceData?.repaymentMode === "Installment" && (
              <>
                <Grid size={{ xs: 12, sm: 4, lg: 6 }}>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Month<span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                  <MaterialInput
                    name="installMonth"
                    type="number"
                    value={advanceData.installMonth || ""}
                    placeholder="eg.12"
                    error={
                      advanceData.installMonthStatus === "error" ? true : false
                    }
                    inputProps={{
                      maxLength: 2,
                    }}
                    onKeyDown={(e) => {
                      if (["e", "E", "+", "-"].includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    sx={{
                      "& input::-webkit-inner-spin-button, & input::-webkit-outer-spin-button":
                        {
                          WebkitAppearance: "none",
                          margin: 0,
                        },
                      "& input": {
                        MozAppearance: "textfield",
                      },
                    }}
                    onChange={handleAmountError}
                    success={advanceData.installMonthStatus === "success"}
                    disabled={togglePage.view || !advanceData?.amount}
                  />
                  {advanceData.installMonthStatus === "error" && (
                    <FormControl error>
                      <FormHelperText>
                        Installment Month should contain only numbers and accept
                        values from 1 to 12.
                      </FormHelperText>
                    </FormControl>
                  )}
                </Grid>
                <Grid size={{ xs: 12, sm: 4, lg: 6 }}>
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Installment Amount<span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                  <MaterialInput
                    name="installAmount"
                    type="number"
                    value={advanceData.installAmount || ""}
                    placeholder="eg. 10000"
                    error={advanceData.amountStatus === "error" ? true : false}
                    inputProps={{
                      maxLength: 50,
                    }}
                    onKeyDown={(e) => {
                      if (["e", "E", "+", "-"].includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    sx={{
                      "& input::-webkit-inner-spin-button, & input::-webkit-outer-spin-button":
                        {
                          WebkitAppearance: "none",
                          margin: 0,
                        },
                      "& input": {
                        MozAppearance: "textfield",
                      },
                    }}
                    onChange={handleAmountError}
                    success={advanceData.amountStatus === "success"}
                    disabled
                    icon={{
                      direction: "right",
                      component: (
                        <Icon color="action" fontSize="small">
                          <CurrencyRupeeIcon />
                        </Icon>
                      ),
                    }}
                  />
                </Grid>
              </>
            )}
          </Grid>
        </CardContent>
        <MaterialBox
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
        >
          {togglePage?.edit && (
            <>
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                onClick={handleDiscard}
              >
                Discard
              </MaterialButton>
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                disabled={!checkAllFields()}
                onClick={handleSubmitSalaryAdvance}
              >
                Update
              </MaterialButton>
            </>
          )}
          {!togglePage?.view && !togglePage?.edit && (
            <>
              <MaterialButton
                sx={{ m: 2 }}
                variant="gradient"
                color="dark"
                onClick={handleSubmitSalaryAdvance}
                disabled={!checkAllFields()}
              >
                {togglePage.edit ? "Update" : "Submit"}
              </MaterialButton>
            </>
          )}
        </MaterialBox>
      </Card>
    </DashboardLayout>
  );
};

export default SalaryAdvance;
